module.exports = __webpack_public_path__ + "img/calendar2-week-fill.3a192403.svg";